import PhoneInput from 'react-phone-input-2';
import React from 'react';
import PropTypes from 'prop-types';

const PhoneNumber = ({ value, setValue, disabled, ...props }) => {
    return (
        <PhoneInput
            specialLabel={''}
            country={'nz'}
            value={value}
            onChange={(phone) => setValue(phone)}
            enableSearch={true}
            disabled={disabled}
            disableDropdown={disabled}
            preferredCountries={['nz', 'au']}
            countryCodeEditable={false}
            {...props}
        />
    );
};

PhoneNumber.propTypes = {
    value: PropTypes.string,
    setValue: PropTypes.func,
    disabled: PropTypes.bool,
};

PhoneNumber.defaultProps = {
    value: '',
    disabled: false,
};

export default PhoneNumber;
